<template>
    <div class="lealtad-section">
        <div class="lealtad-content">
            <h2 class="lealtad-title fuente-posm">
                Implementa un Programa de Lealtad
            </h2>
            <p class="lealtad-text fuente-nova">
                No se trata solo de puntos. Diseñamos experiencias de lealtad que conectan con tus clientes y refuerzan lo que te hace único.
                <br><br>
                Desde el diseño hasta las reglas, todo estará alineado contigo.
            </p>
        </div>
        <div class="lealtad-image">
            <img :src="a23" alt="Programa de Lealtad">
        </div>
    </div>
</template>

<script>
export default {
    name: 'LealtadRewardNew',
    data() {
        return {
            a23: require('@/assets/images/a23.webp')
        }
    }
}
</script>

<style lang="css" scoped>
.lealtad-section {
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 40px 60px;
    box-sizing: border-box;
    scroll-snap-align: start;
    gap: 40px;
    background-color: #272727;
}

.lealtad-content {
    flex: 1;
    max-width: 600px;
    order: 1;
}

.lealtad-title {
    color: var(--color-5);
    font-size: 68px;
    line-height: 1.1;
    margin: 0 0 20px 0;
}

.lealtad-text {
    color: var(--color-5);
    font-size: 27px;
    line-height: 1.3;
    margin: 0;
    padding-left: 10px;
}

.lealtad-image {
    flex: 0 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    order: 2;
}

.lealtad-image img {
    width: 100%;
    max-width: 500px;
    height: auto;
}

/* Tablet */
@media (max-width: 992px) and (min-width: 769px) {
    .lealtad-title {
        font-size: 60px;
    }

    .lealtad-text {
        font-size: 25px;
    }

    .lealtad-image img {
        max-width: 400px;
    }
}

/* Mobile */
@media (max-width: 768px) {
    .lealtad-section {
        flex-direction: column;
        justify-content: flex-start;
        height: 100vh;
        padding: 100px 20px 40px 20px;
        gap: 20px;
    }

    .lealtad-content {
        order: 1;
        max-width: 100%;
        flex: none;
    }

    .lealtad-image {
        order: 2;
        width: 100%;
        flex: 1;
        display: flex;
        align-items: flex-start;
        justify-content: center;
        padding-top: 20px;
    }

    .lealtad-image img {
        width: 90%;
        max-width: 350px;
    }

    .lealtad-title {
        font-size: 24px;
        line-height: 1.2;
        margin: 0 0 10px 0;
    }

    .lealtad-text {
        font-size: 16px;
        padding-left: 10px;
        margin: 0;
    }
}
</style>
